import useSWR from "swr";

import { api } from 'api';

function usePlayerList(year = "current") {

    const fetcher = async () => {
        const response = await api.player.getPlayerList(year);
        return response.data;
    }

    const { data, error, isLoading, mutate } = useSWR(
        `player-list/${year}`,
        fetcher
    );

    return {
        playerList: data || [],
        playerListError: error,
        playerListLoading: isLoading,
        mutatePlayerList: mutate,
    }
}

export default usePlayerList;
